import React, { useMemo } from 'react';
import { ColorSegments } from './ColorSegments';
import { FlexCenter } from '../layout/FlexCenter/FlexCenter';
import { TextCustom } from '../ui/TextCustom';
import { PanelLayout } from '../layout/Panel/Panel';
import { Spacing } from '../layout/Spacing/Spacing';
import { SpacingCustom } from '../layout/Spacing/SpacingCustom';



export interface IDataItem{
  label: string;
  color: string;
}

type TFormat = 'pdf' | 'xlsm' | 'zip' | 'pptx' | 'dxf'

export interface IData {
    format: TFormat, 
    filename: string,
    data: IDataItem[]
}

// export interface IGroupedData {
//   [key in TFormat]: IData[];  // Mapiranje svakog formata na niz podataka
// }

export interface IGroupedData {
  name: string,
  data: IData[],
}

const data: IData[] = [
  {
    format: 'pdf',
    filename: "filename_01",
    data: [
      { label: 'Segment 1', color: '#77b800' },
      { label: 'Segment 2', color: '#83bc3f' },
      { label: 'Segment 3', color: '#9fc97c' },
      { label: 'Segment 4', color: '#bdd8aa' },
      { label: 'Segment 5', color: '#d6e6cb' },
      { label: 'Segment 6', color: '#ebf3e6' },
      { label: 'Segment 1', color: '#77b800' },
      { label: 'Segment 2', color: '#83bc3f' },
      { label: 'Segment 3', color: '#9fc97c' },
      { label: 'Segment 4', color: '#bdd8aa' },
      { label: 'Segment 5', color: '#d6e6cb' },
      { label: 'Segment 6', color: '#ebf3e6' },
      { label: 'Segment 1', color: '#77b800' },
      { label: 'Segment 2', color: '#83bc3f' }
      
    ]
  },
  {
    format:'xlsm',
    filename: "filename_02",
    data: [
      { label: 'Segment 1', color: '#f07b05' },
      { label: 'Segment 2', color: '#f18640' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' },
      { label: 'Segment 5', color: '#f9d7cc' },
      { label: 'Segment 1', color: '#f07b05' },
      { label: 'Segment 2', color: '#f18640' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' },
      { label: 'Segment 5', color: '#f9d7cc' },
      { label: 'Segment 1', color: '#f07b05' },
      { label: 'Segment 2', color: '#f18640' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' }
    ]
  },
  {
    format:'zip',
    filename: "filename_03",
    data: [
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
    ]
  },
  {
    format:'pptx',
    filename: "filename_04",
    data: [
      { label: 'Segment 1', color: '#f07b05' },
      { label: 'Segment 2', color: '#f18640' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' },
      { label: 'Segment 5', color: '#f9d7cc' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' },
      { label: 'Segment 5', color: '#f9d7cc' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' },
      { label: 'Segment 5', color: '#f9d7cc' },
    ]
  },
  {
    format:'dxf',
    filename: "filename_05",
    data: [
      { label: 'Segment 1', color: '#77b800' },
      { label: 'Segment 2', color: '#83bc3f' },
      { label: 'Segment 3', color: '#9fc97c' },
      { label: 'Segment 4', color: '#bdd8aa' },
      { label: 'Segment 5', color: '#d6e6cb' },
    ]
  },
  {
    format:'dxf',
    filename: "filename_06",
    data: [
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
    ]
  },
  {
    format:'dxf',
    filename: "filename_07",
    data: [
      { label: 'Segment 1', color: '#f07b05' },
      { label: 'Segment 2', color: '#f18640' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' },
      { label: 'Segment 5', color: '#f9d7cc' },
      { label: 'Segment 1', color: '#f07b05' },
      { label: 'Segment 2', color: '#f18640' },
      { label: 'Segment 3', color: '#f3a17c' },
      { label: 'Segment 4', color: '#f6bfaa' }
    ]
  },
  {
    format:'dxf',
    filename: "filename_08",
    data: [
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      { label: 'Segment 2', color: '#173777' },
      { label: 'Segment 3', color: '#3f4b83' },
      { label: 'Segment 4', color: '#7c80a0' },
      { label: 'Segment 1', color: '#002878' },
      
    ]
  },
  
]


const CircularPlot = () => {
    const SIZE = 800;
    const CIRCLE_OFFSET = 80;
    const COLOR_CIRCLE_GAP = 0;
    const COLOR_CIRCLE_WIDTH = 150;
    const FILL_ANGLE = 360;
    const ROTATION_OFFSET = 65;
    const LABEL_DISTANCE = 30;
    const SEGMENT_GAP = 0;

    const centerX = SIZE/2;
    const centerY = SIZE/2;
    
    const radius = SIZE/2 - CIRCLE_OFFSET;

    // Group segment per format
    const groupedData = useMemo(()=>{
      return data.reduce((acc, item) => {
        const existingGroup = acc.find(group => group.name === item.format);
        if (existingGroup) {
          existingGroup.data.push(item);
        } else {
          acc.push({
            name: item.format,
            data: [item]
          });
        }
        return acc;
      }, [] as IGroupedData[]);
    }, [data])

    const numberOfDifferentData = groupedData.length;
    const colorCircleWidth = radius / numberOfDifferentData - COLOR_CIRCLE_WIDTH / numberOfDifferentData;
    const numberOfRings = numberOfDifferentData;

    const angleStep = useMemo(()=>(2 * Math.PI) / data[0].data.length,[data]);

    return (
      <SpacingCustom marginTop={2}>

        <FlexCenter direction='v' position='start'>
            <svg width={SIZE} height={SIZE}>
                {/* Koncentrični krugovi */}
                {
                  [...Array(numberOfRings + 1)].map((_, idx: number) => {
                      // const circles = radius - idx * (radius/numberOfRings);
                      const circles = radius - idx * colorCircleWidth;
                      return <circle key={idx} cx={centerX} cy={centerY} r={circles} fill="none" stroke="#ccc" />
                    }
                  )
                }

                {/* Segmenti sa bojama između unutrašnjeg i spoljnog radijusa */}
                {
                  groupedData.map((item: IGroupedData, idx: number)=>{
                    const outerRadius = radius - (idx * colorCircleWidth + COLOR_CIRCLE_GAP);
                    const innerRadius = radius - ((idx + 1) * colorCircleWidth - COLOR_CIRCLE_GAP)
                    return (
                      <ColorSegments
                        key={idx} 
                        label={item.name}
                        data={item.data} 
                        centerX={centerX} 
                        centerY={centerY} 
                        outerRadius={outerRadius} 
                        innerRadius={innerRadius} 
                        fillAnge={FILL_ANGLE} 
                        rotationOffset={ROTATION_OFFSET} 
                        segmentGap = {SEGMENT_GAP}
                      />
                    )
                  })
                }

                {/* Tekst */}
                {data[0].data.map((item, index) => {
                    const angle = index * angleStep + angleStep / 2;
                    const textX = centerX + (radius + LABEL_DISTANCE) * Math.cos(angle);
                    const textY = centerY + (radius + LABEL_DISTANCE) * Math.sin(angle);

                    return (
                        <text className="chart-text" key={index} x={textX} y={textY} textAnchor="middle" fontSize="10" transform={`rotate(${(angle * 180) / Math.PI}, ${textX}, ${textY})`}>
                            {item.label}
                        </text>
                    );
                })}
            </svg>
                <PanelLayout>
                  <Spacing marginSpacing='l' paddingSpacing='l'>
                    <FlexCenter position='start' direction='h' gap={1}>
                      {
                        data.map((item: IData, idx: number)=>{
                          return (
                            <FlexCenter stretch key={idx} gap={1} direction='v'>
                              <TextCustom color='dark'>{item.filename}</TextCustom>
                              <div style={{width:'24px', height:'24px', backgroundColor:`${item.data[0].color}`, borderRadius:'.5rem'}}></div>
                            </FlexCenter>
                          )
                        })
                      }
                    </FlexCenter>
                  </Spacing>
                </PanelLayout>

        </FlexCenter>
      </SpacingCustom>
    );
};

export default CircularPlot;
